import React from 'react';
import { Segment } from './types';
import StoreAddress from './StoreAddress';
import LineItem from './LineItem';
import ProgressBar from '../ProgressBar';
import { prependLocaleToPath } from '../../../../utils/localization';

const ShipmentCard = ({
  segment,
  totalSegments,
  orderId,
  email,
  orderShippingCountryCode,
}: {
  segment: Segment;
  totalSegments: number;
  orderId: string;
  email: string | null;
  orderShippingCountryCode: string;
}) => {
  const returnCopy = segment?.return_portal_url?.toLowerCase().includes('global')
    ? 'Start A Return'
    : 'Return Or Exchange';
  return (
    <div className="shipment">
      <div className="shipment-header">
        <div className="tracking-status">
          <p className="body-large">
            Shipment {segment.sequence}/{totalSegments}
          </p>
          <p className="editorial-large">{segment.display_status}</p>
          <p className="body-small">{segment.status_message}</p>
          {(segment.type === 'pickup' || segment.type === 'in_store') && segment.store_location ? (
            <div className="">
              <StoreAddress location={segment.store_location} />
            </div>
          ) : null}
          {segment.progress ? <ProgressBar percentage={segment.progress} /> : null}
        </div>
        {segment.shipment?.tracking_number || segment.return_eligible ? (
          <div className="tracking-return">
            {segment.shipment?.tracking_number && (
              <a
                href={prependLocaleToPath(
                  `/pages/order-tracking?order_reference=${orderId}&tracking_number=${
                    segment.shipment?.tracking_number
                  }${email ? `&email=${encodeURIComponent(email)}` : ''}`
                )}
                className="button button-primary-md"
              >
                Track Shipment
              </a>
            )}
            {segment.return_eligible && segment.return_portal_url ? (
              <a href={segment.return_portal_url} className="button button-ghost-md">
                {returnCopy}
              </a>
            ) : null}
          </div>
        ) : null}
      </div>
      <div className="shipment-line-items">
        {segment.items.map((item) => (
          <LineItem
            item={item}
            returnExchangeCopy={item.return_status}
            orderShippingCountryCode={orderShippingCountryCode}
          />
        ))}
      </div>
    </div>
  );
};

export default ShipmentCard;
